import { faArrowCircleLeft } from "@fortawesome/pro-solid-svg-icons/faArrowCircleLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcText } from "components";

export const DashboardBack = () => {
    return (
        <MprcText color={["primary", "light"]}>
            <FontAwesomeIcon icon={faArrowCircleLeft} size="2x" color="primary" />
        </MprcText>
    );
};
